(function (angular) {
    'use strict';

    angular
        .module('app.purchase')
        .controller('app.purchase.membershipAgreementsController', [
            '$scope',
            '$http',
            '$sce',
            '$uibModalInstance',
            '$rootScope',
            'app.purchase.purchaseFlowService',
            membershipAgreementsController
        ]);

    function membershipAgreementsController($scope, $http, $sce,$uibModalInstance, $rootScope, purchaseFlowService) {
        var vm = this;
        vm.siteContent = siteContent;
        vm.done = done;
        vm.dismiss = dismiss;
        vm.agreementChange = agreementChange;
        vm.signInOptionClick = signInOptionClick;
        vm.authenticateOTP = authenticateOTP;
        vm.userInfo = purchaseFlowService.getUserInfo();
        vm.signInOption = "password";
        vm.memberPortalSignIn = environment.memberPortalUrl;
        vm.rememberLogin = true;
        vm.code = '';       

        vm.membershipAgreement = false;
        vm.userState = '';
        vm.blobStorageUrl = environment.blobStorageTopUrl;
        vm.urlSafe = 'https://wellfitqa.blob.core.windows.net/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'
        vm.memberAgreementUrl = environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf';
                
        onInit();

        function onInit() {            
            vm.userState = $rootScope.personState;
            if (vm.userState == 'CA') {
                vm.memberAgreementUrl = vm.blobStorageUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_California_2024.pdf';
              } else if (vm.userState == 'WA') {
                vm.memberAgreementUrl = vm.blobStorageUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Washington.pdf';    
              } else {
                vm.memberAgreementUrl = environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_2024.pdf';
              }
              
            vm.urlSafe = $sce.trustAsResourceUrl(vm.memberAgreementUrl);
        }
        //Close the modal
        function done() {
            $uibModalInstance.close(true);
        }

        function agreementChange() {            
            if (vm.membershipAgreement == true) {
                $uibModalInstance.close(true);
            }
          }

        function dismiss() {
            $uibModalInstance.close(false);
        }

        function signInOptionClick() {
            if(vm.signInOption === 'otp') {
                purchaseFlowService
                .generateOTP(vm.userInfo.emailAddress)
                .then(function (){
                })
                .finally(function () {
                    //ui.unblock();
                });
            }
        }

        function authenticateOTP() {
            var result = null;
            if(vm.signInOption === 'otp') {
                purchaseFlowService
                .authenticateOTP({userName: vm.userInfo.emailAddress, oneTimePassword: vm.code, rememberLogin: vm.rememberLogin}, vm)
                .then(function (results){
                    result = results;
                })
                .finally(function () {
                    //ui.unblock();
                    vm.dismiss();
                    if (vm.userInfo.emailAddress != null && vm.userInfo.emailAddress != '') {
                        window.location = vm.memberPortalSignIn + '&otp_token=' + results.otpToken;
                    }
                });
            } else if(vm.signInOption === 'password') {
                purchaseFlowService
                .signIn({email: vm.userInfo.emailAddress, password: vm.code, rememberLogin: vm.rememberLogin}, vm)
                .then(function (){
                })
                .finally(function () {
                    //ui.unblock();
                    vm.dismiss();
                    if (vm.userInfo.emailAddress != null && vm.userInfo.emailAddress != '') {
                        window.location = vm.memberPortalSignIn;
                    }
                });
            }
        }
    }

})(angular);
